import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft, BookOpen, Shield, FileText, Download, Lock } from 'lucide-react';

// Production-safe API host: same-origin in deployed builds, env var in preview.
const _ENV_BACKEND = process.env.REACT_APP_BACKEND_URL || '';
const _ORIGIN = typeof window !== 'undefined' ? window.location.origin : '';
const _isPreviewEnv = /preview\.emergentagent\.com$/.test(
  (typeof window !== 'undefined' && window.location.hostname) || ''
);
const API = _isPreviewEnv ? _ENV_BACKEND : (_ORIGIN || _ENV_BACKEND);

const RESOURCES = [
  { id: 'nclex-pn-bank', title: 'NCLEX-PN Bonus Question Bank', desc: '250-item supplemental question bank covering pharmacology, OB, mental health, and prioritization.', icon: BookOpen },
  { id: 'nclex-rn-bank', title: 'NCLEX-RN Bonus Question Bank', desc: '300-item supplemental bank — Next-Generation NCLEX bow-tie items included.', icon: BookOpen },
  { id: 'ethics-template', title: 'Code of Ethics Template', desc: 'Editable Word/PDF for non-licensed wellness practitioners. Print, sign, and post.', icon: Shield },
  { id: 'consent-template', title: 'Informed Consent Template', desc: 'HIPAA-aware client intake & informed-consent form template.', icon: FileText },
  { id: 'policy-pack', title: 'Practice Policy Pack', desc: 'Cancellation, refund, confidentiality, and emergency-referral policies. Drop-in templates.', icon: FileText },
  { id: 'med-safety-card', title: 'Medication Safety Reference Card', desc: 'Wallet-sized PDF: Six Rights, Three Checks, look-alike / sound-alike drugs.', icon: BookOpen },
];

const MembershipLibrary = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [isMember, setIsMember] = useState(false);

  useEffect(() => {
    const raw = localStorage.getItem('user');
    if (!raw) { navigate('/login?return=/membership/library'); return; }
    const u = JSON.parse(raw);
    fetch(`${API}/api/membership/status/${u.id || u._id}`)
      .then((r) => r.json())
      .then((d) => setIsMember(!!d.is_member))
      .finally(() => setLoading(false));
  }, [navigate]);

  if (loading) {
    return <div style={{ minHeight: '100vh', background: '#0f172a', color: '#94a3b8', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Loading…</div>;
  }

  if (!isMember) {
    return (
      <div style={{ minHeight: '100vh', background: '#0f172a', color: '#e2e8f0', padding: 40 }}>
        <div style={{ maxWidth: 600, margin: '60px auto', textAlign: 'center', background: 'rgba(255,255,255,0.04)', padding: 40, borderRadius: 14 }}>
          <Lock size={42} color="#f87171" />
          <h1 style={{ fontSize: '1.8rem', color: '#f8fafc', marginTop: 16 }}>Members-only library</h1>
          <p style={{ color: '#cbd5e1', marginTop: 10 }}>Join the MedCare Association for $9.99 / month to unlock the bonus question banks, ethics templates, and study guides.</p>
          <Link to="/association" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '12px 24px', borderRadius: 999, background: 'linear-gradient(90deg,#14b8a6,#a78bfa)', color: 'white', fontWeight: 700, textDecoration: 'none', marginTop: 22 }}>
            Become a Member
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#0f172a', color: '#e2e8f0' }}>
      <div style={{ padding: '20px 40px', display: 'flex', gap: 20 }}>
        <Link to="/membership/dashboard" style={{ display: 'inline-flex', gap: 8, color: '#cbd5e1', textDecoration: 'none' }}>
          <ArrowLeft size={18} /> Back to dashboard
        </Link>
      </div>
      <section style={{ maxWidth: 1100, margin: '0 auto', padding: '20px 40px 60px' }}>
        <h1 style={{ fontSize: '2rem', color: '#f8fafc' }}>Members-Only Resource Library</h1>
        <p style={{ color: '#94a3b8', marginTop: 8 }}>Six bonus resources to support your practice. New items added monthly.</p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(320px,1fr))', gap: 16, marginTop: 24 }}>
          {RESOURCES.map((r) => {
            const I = r.icon;
            return (
              <div key={r.id} data-testid={`library-resource-${r.id}`} style={{ background: 'rgba(255,255,255,0.04)', borderRadius: 12, padding: 22, border: '1px solid rgba(255,255,255,0.06)' }}>
                <I size={24} color="#5eead4" />
                <div style={{ color: '#f8fafc', fontWeight: 700, marginTop: 10 }}>{r.title}</div>
                <p style={{ color: '#94a3b8', fontSize: '0.92rem', marginTop: 6, lineHeight: 1.55 }}>{r.desc}</p>
                <button type="button" style={{ display: 'inline-flex', gap: 6, alignItems: 'center', marginTop: 10, color: '#5eead4', background: 'transparent', border: 0, cursor: 'pointer', fontWeight: 600 }} onClick={() => alert('Resource coming soon — download wiring in flight.')}>
                  <Download size={14} /> Download
                </button>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
};

export default MembershipLibrary;
